export const header = {
	aboutMeTitle: 'About Me',
	careerTitle: 'Career',
	skillsTitle: 'Skills',
	projectsTitle: 'Projects',
};
